import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import type { DepartmentFormSchema } from './department-form-schema';

import { settingsBcLink } from '../../model';

export const defaultValues = {
  id: -1,
  name: '',
  description: '',
  status: defaultStatus,
  parent: null,
} as DepartmentFormSchema;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/departments', name: 'Departments' },
];
